export default __webpack_public_path__ + "static/media/white_2_dirtywhite_stone_sunglasses_closed_squiggle_normal.ada12792.png";